export default "__VITE_ASSET__M7Gx7CLG__"